import { usersServiceApi } from '@/config/api';
import { apiPost } from './httpClient';

/** POST /users — сохранение собственных имени и фамилии. Успех — 204 без тела. */
export interface ProfileUpdate {
  name: string;
  surname: string;
}

export async function updateOwnProfile(update: ProfileUpdate): Promise<void> {
  await apiPost(usersServiceApi.url(usersServiceApi.endpoints.updateProfile), {
    name: update.name,
    surname: update.surname,
  });
}
